import * as React from 'react';

import { Button, PageNotification } from '@coursera/cds-core';

type Props = {
  severity: 'error' | 'warning' | 'success' | 'information';
  title?: string;
  description: React.ReactChild;
  buttonLabel?: string;
  onButtonClick?: () => void;
  onDismiss?: () => void;
};

const EnterpriseAdminNotificationBanner: React.FC<Props> = (props) => {
  const { severity, title, description, buttonLabel, onButtonClick, onDismiss } = props;
  return (
    <PageNotification
      title={title}
      severity={severity}
      primaryAction={
        <Button variant="primary" onClick={onButtonClick}>
          {buttonLabel}
        </Button>
      }
      onDismiss={onDismiss}
    >
      {description}
    </PageNotification>
  );
};

export default EnterpriseAdminNotificationBanner;
